import Lottie from 'lottie-react';
import animationLoaderLottie from './animationLoaderLottie.json';
import { FC } from 'react';

interface IBordAnimationLoader {
  width?: string;
  lottieCustomClassName?: string;
}

const BordAnimationLoader: FC<IBordAnimationLoader> = ({
  width = '14.3rem',
  lottieCustomClassName
}: IBordAnimationLoader) => {
  return (
    <div id="animationLoader">
      <Lottie className={lottieCustomClassName || ''} style={{ width: width }} animationData={animationLoaderLottie} />
    </div>
  );
};

export default BordAnimationLoader;
